// filepath: /my-react-app/my-react-app/src/services/ConfigurationError.ts
export class ConfigurationError extends Error {
    constructor(message: string) {
      super(message);
      this.name = "ConfigurationError";
    }
  }